export default {
  CPD_AWARDS: (id) => `cpd_awards/awards?memberNo=${id}`,
};
